export enum CardsViews {
    NoCards = 'NoCards',
    NewCards = 'NewCards',
    NewCard = 'NewCard',
    Cards = 'Cards',
}
